import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const Panel = styled.div``;

export const PillGroup = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space[2]};
  padding: ${space[4]} 0;
`;

export const FormSection = styled.div`
  padding-top: ${space[3]};
`;

export const GenderSection = styled.div`
  padding-top: ${space[4]};
`;

export const GenderLabel = styled.span`
  display: block;
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin-bottom: ${space[3]};
`;
